import React from "react";
import LegalLayout, { Section, Placeholder } from "./LegalLayout";
import { CONTACT } from "../../mock";

const PolitiqueConfidentialite = () => {
  return (
    <LegalLayout
      title="Politique de confidentialité"
      subtitle="Protection des données"
      updated="Janvier 2025"
    >
      <p className="text-white/60 mb-8 leading-relaxed">
        BS Import Auto accorde une grande importance à la protection de vos données
        personnelles. La présente politique explique quelles données sont
        collectées, pourquoi, et quels sont vos droits, conformément au Règlement
        Général sur la Protection des Données (RGPD) et à la loi Informatique et
        Libertés.
      </p>

      <Section title="1. Responsable du traitement">
        <p>
          Le responsable du traitement des données est BS Import Auto,{" "}
          <Placeholder>[coordonnées – à compléter]</Placeholder>. Pour toute
          question relative à vos données : <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>.
        </p>
      </Section>

      <Section title="2. Données collectées">
        <p>Nous collectons uniquement les données nécessaires aux finalités décrites ci-dessous :</p>
        <ul>
          <li><strong>Formulaire de contact / demande :</strong> prénom, nom, e-mail, contenu du message.</li>
          <li><strong>Réservation d'un service ou d'une formation :</strong> nom, e-mail, téléphone, prestation souhaitée.</li>
          <li><strong>Paiement en ligne :</strong> les données bancaires sont traitées directement et exclusivement par notre prestataire de paiement sécurisé Stripe. Nous ne stockons jamais vos coordonnées bancaires.</li>
          <li><strong>Données techniques :</strong> données de navigation et cookies strictement nécessaires au bon fonctionnement du site.</li>
        </ul>
      </Section>

      <Section title="3. Finalités et bases légales">
        <ul>
          <li>Répondre à vos demandes de contact et vous fournir un devis — <em>intérêt légitime / mesures précontractuelles</em>.</li>
          <li>Gérer les réservations et l'exécution des prestations et formations — <em>exécution du contrat</em>.</li>
          <li>Traiter les paiements — <em>exécution du contrat</em>.</li>
          <li>Respecter nos obligations légales et comptables — <em>obligation légale</em>.</li>
        </ul>
      </Section>

      <Section title="4. Destinataires des données">
        <p>
          Vos données sont destinées à BS Import Auto et, le cas échéant, à ses
          sous-traitants strictement nécessaires : prestataire de paiement (Stripe),
          hébergeur du site et service d'acheminement des e-mails. Aucune donnée
          n'est vendue ni cédée à des tiers à des fins commerciales.
        </p>
      </Section>

      <Section title="5. Durée de conservation">
        <p>
          Les données de contact et de prospection sont conservées pour une durée
          maximale de 3 ans à compter du dernier contact. Les données liées à une
          prestation ou un paiement sont conservées le temps nécessaire à
          l'exécution du contrat puis archivées conformément aux durées légales
          (notamment comptables et fiscales).
        </p>
      </Section>

      <Section title="6. Vos droits">
        <p>
          Conformément au RGPD, vous disposez d'un droit d'accès, de rectification,
          d'effacement, de limitation, d'opposition et de portabilité de vos
          données. Vous pouvez exercer ces droits à tout moment en écrivant à{" "}
          <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>.
        </p>
        <p>
          Vous disposez également du droit d'introduire une réclamation auprès de la
          Commission Nationale de l'Informatique et des Libertés (CNIL) —{" "}
          <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer">www.cnil.fr</a>.
        </p>
      </Section>

      <Section title="7. Cookies">
        <p>
          Le site utilise des cookies strictement nécessaires à son fonctionnement
          et à la sécurisation des paiements (Stripe). Aucun cookie publicitaire ni
          de suivi marketing n'est déposé sans votre consentement. Vous pouvez
          configurer votre navigateur pour refuser les cookies non essentiels.
        </p>
      </Section>

      <Section title="8. Sécurité">
        <p>
          BS Import Auto met en œuvre des mesures techniques et organisationnelles
          appropriées afin de protéger vos données contre tout accès, perte ou
          divulgation non autorisés. Les paiements sont sécurisés par un prestataire
          certifié conforme aux normes du secteur (PCI-DSS).
        </p>
      </Section>

      <p className="text-white/40 text-sm mt-10 leading-relaxed">
        Les mentions signalées en orange doivent être complétées avec vos
        informations réelles avant la mise en ligne définitive.
      </p>
    </LegalLayout>
  );
};

export default PolitiqueConfidentialite;
